import { head, isEmpty, orderBy } from 'lodash';
import helper from './helper';

export default (xScale, mouseEvents) => (selection) => {
  const data = head(selection.data());
  const { destinations, origin } = data;
  const { onDropClick, onDropMouseover, onDropMouseout } = mouseEvents;
  const { inRange } = helper;
  const domain = xScale.domain();

  selection.selectAll('.drops').remove();

  const drops = selection.selectAll('.drops').data(d => Array(d));
  const gDrops = drops
    .enter()
    .append('g')
    .classed('drops', true);

  const originDrop = gDrops.selectAll('.drop__origin').data([origin]);
  originDrop
    .enter()
    .append('circle')
    .classed('drop', true)
    .classed('drop__origin', true)
    .style('cursor', 'pointer')
    .on('mouseover', onDropMouseover('origin'))
    .on('mouseout', onDropMouseout())
    .attr('fill', () => (domain[0] > 0 ? 'transparent' : '#46A8F6'))
    .style('pointer-events', () => (domain[0] > 0 ? 'none' : 'auto'))
    .attr('r', 5)
    .attr('cy', 42)
    .attr('cx', xScale(0));

  let distanceCalc = 0;
  let distanceSummary = 0;
  let distanceCalcFill = 0;
  const ordered = orderBy(destinations, ['percentage'], ['desc']);
  const destinationDrops = gDrops.selectAll('.drop__destination').data(ordered);
  destinationDrops
    .enter()
    .append('circle')
    .classed('drop', true)
    .classed('drop__destination', true)
    .on('click', onDropClick('destination'))
    .on('mouseover', onDropMouseover('destination'))
    .on('mouseout', onDropMouseout())
    .style('cursor', 'pointer')
    .attr('fill', (d) => {
      distanceCalc += !isEmpty(d.direction) ? d.direction.distance : 0;
      return inRange(distanceCalc, domain[0], domain[1]) ? '#46A8F6' : 'transparent';
    })
    .style('pointer-events', (d) => {
      distanceCalcFill += !isEmpty(d.direction) ? d.direction.distance : 0;
      return inRange(distanceCalcFill, domain[0], domain[1]) ? 'auto' : 'none';
    })
    .attr('r', 5)
    .attr('cy', 42)
    .attr('cx', (d) => {
      distanceSummary += !isEmpty(d.direction) ? d.direction.distance : 0;
      return xScale(distanceSummary);
    });

  return drops;
};



// WEBPACK FOOTER //
// ./src/components/dashboard_widgets/shipment_completion/drops.js